import DashboardLayout from "../pages/Dashboard/Layout/DashboardLayout.vue";
import CategoriaList from '../views/cadastros/categoria/List.vue';
import ItensCategoriaList from '../views/cadastros/itens_categoria/List.vue';
import ModeloCheckList from '../views/cadastros/modelo_checklist/List.vue';

let modeloRoutes = {
    path: "/modelos",
    component: DashboardLayout,
    name: "Modelos CheckList",
    icon: "spellcheck",
    redirect: "/modelos/checklist",
    children: [
        {
            path: "checklist",
            name: "Modelos de CheckList",
            icon: "image",
            component: ModeloCheckList
        },
        {
            path: "categorias",
            name: "Categorias",
            icon: "image",
            component: CategoriaList
        },
        {
            path: "itens",
            name: "Itens de CheckList",
            title: "Itens de Checklist",
            icon: "image",
            component: ItensCategoriaList
        },
    ]
};

export default modeloRoutes;